import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _BaseResultsFeedback;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';
import { Flex, PARENT_TYPE_QUIZ, withStyleOverrides } from '@instructure/quiz-common';
import { RichContentInput, RichContentRenderer } from '@instructure/quiz-rce';
import t from '@instructure/quiz-i18n/format-message';
import Setting from '../Setting';
import { Button } from '@instructure/ui-buttons';
import { jsx } from '@instructure/emotion';
import generateComponentTheme from './theme';
import generateStyle from './styles';
var BaseResultsFeedback = /*#__PURE__*/function (_Component) {
  function BaseResultsFeedback() {
    var _this2;
    _classCallCheck(this, BaseResultsFeedback);
    _this2 = _callSuper(this, BaseResultsFeedback, arguments);
    _defineProperty(_this2, "state", {
      editing: !_this2.hasInitialContent()
    });
    _defineProperty(_this2, "startEdit", function () {
      _this2.setState({
        editing: true
      });
    });
    _defineProperty(_this2, "endEdit", function () {
      _this2.setState({
        editing: false
      });
    });
    _defineProperty(_this2, "toggleResultsFeedbackEnabled", function (event, changeCompleteCb) {
      var _this2$props = _this2.props,
        activeQuizId = _this2$props.activeQuizId,
        setResultsFeedbackEnabled = _this2$props.setResultsFeedbackEnabled;
      setResultsFeedbackEnabled(activeQuizId, event.target.checked, changeCompleteCb);
    });
    _defineProperty(_this2, "renderPreview", function () {
      return jsx("div", null, jsx("div", {
        css: _this2.props.styles.contentWrapper
      }, jsx(RichContentRenderer, {
        content: _this2.props.resultsFeedback
      })), jsx(Flex, {
        direction: "row-reverse"
      }, jsx(Button, {
        color: "primary",
        onClick: _this2.startEdit,
        margin: "small 0"
      }, t('Edit Feedback'))));
    });
    _defineProperty(_this2, "renderEditor", function (changeCompleteCb) {
      return jsx("div", null, jsx(RichContentInput, {
        label: "",
        textareaId: "results_feedback",
        defaultContent: _this2.props.resultsFeedback,
        onKeyUp: _this2.setResultsFeedback(changeCompleteCb),
        onChange: _this2.setResultsFeedback(changeCompleteCb),
        parentType: PARENT_TYPE_QUIZ,
        parentId: _this2.props.activeQuizId
      }), jsx(Flex, {
        direction: "row-reverse"
      }, jsx(Button, {
        color: "primary",
        onClick: _this2.endEdit
      }, t('Preview Feedback'))));
    });
    _this2.setResultsFeedback = function (changeCompleteCb) {
      return debounce(function (e, _ref) {
        var editorContent = _ref.editorContent;
        _this2.props.setResultsFeedback(_this2.props.activeQuizId, editorContent, changeCompleteCb);
      }, 500, {
        maxWait: 5000
      });
    };
    return _this2;
  }
  _inherits(BaseResultsFeedback, _Component);
  return _createClass(BaseResultsFeedback, [{
    key: "hasInitialContent",
    value: function hasInitialContent() {
      return this.props.resultsFeedback && this.props.resultsFeedback.length > 0;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      return jsx(Setting, {
        isChecked: this.props.resultsFeedbackEnabled,
        showMore: this.props.resultsFeedbackEnabled,
        label: t('Show custom feedback with results'),
        onChange: this.toggleResultsFeedbackEnabled
      }, function (changeCompleteCb) {
        return _this3.state.editing ? _this3.renderEditor(changeCompleteCb) : _this3.renderPreview();
      });
    }
  }]);
}(Component);
_BaseResultsFeedback = BaseResultsFeedback;
_defineProperty(BaseResultsFeedback, "displayName", 'ResultsFeedback');
_defineProperty(BaseResultsFeedback, "componentId", "Quizzes".concat(_BaseResultsFeedback.displayName));
_defineProperty(BaseResultsFeedback, "propTypes", {
  activeQuizId: PropTypes.string.isRequired,
  resultsFeedback: PropTypes.string,
  resultsFeedbackEnabled: PropTypes.bool,
  setResultsFeedback: PropTypes.func.isRequired,
  setResultsFeedbackEnabled: PropTypes.func.isRequired,
  styles: PropTypes.object
});
_defineProperty(BaseResultsFeedback, "defaultProps", {
  resultsFeedback: null,
  resultsFeedbackEnabled: false
});
export var ResultsFeedback = withStyleOverrides(generateStyle, generateComponentTheme)(BaseResultsFeedback);
export default ResultsFeedback;